import { ToastContainer } from './Toast.styles';

const Toast = ({ message }) => {
    return (
        <ToastContainer className={message ? 'show' : ''}>
            {message}
        </ToastContainer>
    );
};

export default Toast;
